import { useState } from "react";
import { Button, Modal } from "src/Components";
import Config from "./Config";
import {
  getHistoryConfig,
  getHistoryTable,
  syncHistoryData,
} from "src/Requests/history";
import { toast } from "react-toastify";
import { packetErrorHandler } from "src/Utils/requestUtils";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";

const History = () => {
  const [isConfigOpen, setIsConfigOpen] = useState(false);
  const [refreshTableFlag, setRefreshTableFlag] = useState(false);

  const syncDataHandler = () => {
    syncHistoryData()
      .then((resp) => {
        if (resp.data) setRefreshTableFlag(true);
        else toast.error(resp.msg);
      })
      .catch(packetErrorHandler);
  };

  return (
    <div className="flex flex-col justify-start items-start gap-5 w-full p-3">
      {isConfigOpen ? (
        <Modal
          title="ثبت زمان"
          onClose={() => setIsConfigOpen(false)}
          UI={<Config onClose={() => setIsConfigOpen(false)} />}
          modalBoxClassName="!h-[400px]"
        />
      ) : (
        <></>
      )}

      <div className="flex flex-row justify-start items-center gap-5">
        <Button
          text="دریافت اطلاعات"
          variant="contained"
          onClick={syncDataHandler}
        />
        <Button
          text="ثبت زمان"
          variant="outlined"
          onClick={() => setIsConfigOpen(true)}
        />
      </div>
      <TableTemplate
        TableUI={({ reports }) => (
          <CommonTableUI reports={reports} refreshFlag={refreshTableFlag} />
        )}
        getDataTable={getHistoryTable}
        SearchParamUI={null as any}
      />
    </div>
  );
};

export default History;
